export interface LanguageOption {
  value: string;
  label: string;
}

export const OTHER_LANGUAGE_VALUE = "__other__";

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: "Казахский", label: "Казахский" },
  { value: "Русский", label: "Русский" },
  { value: "Английский", label: "Английский" },
  { value: "Азербайджанский", label: "Азербайджанский" },
  { value: "Арабский", label: "Арабский" },
  { value: "Армянский", label: "Армянский" },
  { value: "Белорусский", label: "Белорусский" },
  { value: "Болгарский", label: "Болгарский" },
  { value: "Венгерский", label: "Венгерский" },
  { value: "Вьетнамский", label: "Вьетнамский" },
  { value: "Греческий", label: "Греческий" },
  { value: "Грузинский", label: "Грузинский" },
  { value: "Датский", label: "Датский" },
  { value: "Иврит", label: "Иврит" },
  { value: "Индонезийский", label: "Индонезийский" },
  { value: "Испанский", label: "Испанский" },
  { value: "Итальянский", label: "Итальянский" },
  { value: "Киргизский", label: "Киргизский" },
  { value: "Китайский", label: "Китайский" },
  { value: "Корейский", label: "Корейский" },
  { value: "Малайский", label: "Малайский" },
  { value: "Монгольский", label: "Монгольский" },
  { value: "Немецкий", label: "Немецкий" },
  { value: "Нидерландский", label: "Нидерландский" },
  { value: "Норвежский", label: "Норвежский" },
  { value: "Персидский", label: "Персидский" },
  { value: "Польский", label: "Польский" },
  { value: "Португальский", label: "Португальский" },
  { value: "Румынский", label: "Румынский" },
  { value: "Сербский", label: "Сербский" },
  { value: "Таджикский", label: "Таджикский" },
  { value: "Тайский", label: "Тайский" },
  { value: "Татарский", label: "Татарский" },
  { value: "Турецкий", label: "Турецкий" },
  { value: "Туркменский", label: "Туркменский" },
  { value: "Узбекский", label: "Узбекский" },
  { value: "Уйгурский", label: "Уйгурский" },
  { value: "Украинский", label: "Украинский" },
  { value: "Урду", label: "Урду" },
  { value: "Финский", label: "Финский" },
  { value: "Французский", label: "Французский" },
  { value: "Хинди", label: "Хинди" },
  { value: "Хорватский", label: "Хорватский" },
  { value: "Чешский", label: "Чешский" },
  { value: "Шведский", label: "Шведский" },
  { value: "Японский", label: "Японский" },
];
